import { render, staticRenderFns } from "./relativeNetwork.vue?vue&type=template&id=f1bf05d2&scoped=true"
import script from "./relativeNetwork.vue?vue&type=script&lang=js"
export * from "./relativeNetwork.vue?vue&type=script&lang=js"
import style0 from "./relativeNetwork.vue?vue&type=style&index=0&id=f1bf05d2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1bf05d2",
  null
  
)

export default component.exports